module.exports = __webpack_public_path__ + "img/title.58e812b5.png";